export const fruitData = [
  {
    name: 'Pineapple',
  },
  {
    name: 'Blackberry',
  },
  {
    name: 'Strawberry Sauce',
  },
  {
    name: 'Mango',
  },
  {
    name: 'Blueberries',
  },
  {
    name: 'Maraschino Cherries',
  },
  {
    name: 'Kiwi',
  },
  {
    name: 'Raspberries',
  },
  {
    name: 'Strawberries',
  },
  {
    name: 'Boba (flavors change. 3 Rotating flavors – cherry, strawberry, orange, mango, blueberry, green apple and kiwi)',
  },
  {
    name: 'Caramel Turtles',
  },
  {
    name: 'Brownie Bites',
  },
  {
    name: 'Cheesecake Bites',
  },
  {
    name: 'Reese Peanut Butter Cups',
  },
  {
    name: 'Whipped Cream',
  },
  {
    name: 'Cookie Dough',
  },
];

export default {
  fruitData,
};
